import { AzureDevopsWorkItemLinkPayload } from 'features/azureDevops/types';

import { getRequestV2, postRequestV2 } from '../../methods';

const getAzureDevopsOrganizations = () =>
  getRequestV2('azure_devops/organizations');

const getAzureDevopsProjects = (organizationName: string) =>
  getRequestV2(`azure_devops/organizations/${organizationName}/projects`);

const getAzureDevopsWorkItems = (
  organizationId: string,
  projectName: string,
  search?: string,
  workItemTypes?: string[],
  states?: string[]
) => {
  const base = `azure_devops/organizations/${organizationId}/projects/${projectName}/work_items`;
  const params = new URLSearchParams();
  if (search) params.set('search', search);
  workItemTypes?.forEach(type => params.append('work_item_type[]', type));
  states?.forEach(state => params.append('state[]', state));
  const queryString = params.toString();
  return getRequestV2(queryString ? `${base}?${queryString}` : base);
};

const getAzureDevopsWorkItemTypes = (
  organizationId: string,
  projectName: string
) =>
  getRequestV2(
    `azure_devops/organizations/${organizationId}/projects/${projectName}/work_item_types`
  );

const getAzureDevopsWorkItemStates = (
  organizationId: string,
  projectName: string,
  workItemType: string
) =>
  getRequestV2(
    `azure_devops/organizations/${organizationId}/projects/${projectName}/work_item_types/${encodeURIComponent(
      workItemType
    )}/states`
  );

const createAzureDevopsWorkItems = (payload: AzureDevopsWorkItemLinkPayload) =>
  postRequestV2('azure_devops/work_items', payload);

export default {
  getAzureDevopsOrganizations,
  getAzureDevopsProjects,
  getAzureDevopsWorkItems,
  getAzureDevopsWorkItemTypes,
  getAzureDevopsWorkItemStates,
  createAzureDevopsWorkItems,
};
